module.exports = __webpack_public_path__ + "static/5-3ae1e8f55253617f4c6a9f19bfa8974e.png";